import { render } from "./SchedulationAgenda.vue?vue&type=template&id=6503851f&scoped=true&ts=true"
import script from "./SchedulationAgenda.vue?vue&type=script&lang=ts"
export * from "./SchedulationAgenda.vue?vue&type=script&lang=ts"

import "./SchedulationAgenda.vue?vue&type=style&index=0&id=6503851f&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6503851f"]])

export default __exports__